<template>
    <div class="container mb-80 mb-md-120 mb-xl-160 text-center">
        <div class="row">
            <div class="col-12 col-lg-8 offset-lg-2">
                <h2 class="mb-40" v-if="title.length > 0">{{ title }}</h2>
                <p class="text-cut mb-40 font-weight-light" v-if="description">{{ description }}</p>
                <div>
                    <a v-if="button" :href="link" class="btn btn-lg btn-secondary btn-special">
                        <span>{{ button }}</span>
                    </a>
                    <a v-if="buttonTwo" :href="linkTwo" class="btn btn-lg btn-secondary-inverse btn-special ml-16">
                        <span>{{ buttonTwo }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        button: {
            type: String,
            required: true
        },
        link: {
            type: String,
            required: true
        },
        buttonTwo: {
            type: String,
            required: false
        },
        linkTwo: {
            type: String,
            required: false
        },
    },
}

</script>
